module.exports = __webpack_public_path__ + "build/img/illustration.05e63fb0.png";